import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const requestDeletePosition = (id: number) => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.DELETE,
    path: `/api/v1/clinics/vacancies/${id}`,
  });
};

export default requestDeletePosition;
